// extracted by mini-css-extract-plugin
export default {"container":"_1Rm4DxUS","image":"_4eYdbWfx","desktopImage":"_39bB4aG1","mobileImage":"_2xBZ_jSn"};